import DeleteIcon from "@mui/icons-material/Delete";
import {
    Alert,
    Box,
    Button,
    CircularProgress,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createModule, deleteModule, getModules } from "../../../../actions/fgModuleActions";
import ModuleFormDialog from "../components/ModuleFormDialog";

const ModuleList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { modules, loading, error } = useSelector((state) => state.fgModules);
    const [isDialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        dispatch(getModules());
    }, [dispatch]);

    const handleOpenDialog = () => setDialogOpen(true);
    const handleCloseDialog = () => setDialogOpen(false);

    const handleSubmitModule = (moduleData) => {
        dispatch(createModule(moduleData));
    };

    const handleEditClick = (moduleId) => {
        navigate(`${moduleId}`);
    };

    const handleDeleteClick = (moduleId, moduleName) => {
        if (window.confirm(`Möchten Sie das Modul "${moduleName}" wirklich löschen?`)) {
            dispatch(deleteModule(moduleId));
        }
    };

    if (loading && modules.length === 0) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Alert severity="error" sx={{ mt: 2 }}>
                Fehler beim Laden der Module: {typeof error === "string" ? error : JSON.stringify(error)}
            </Alert>
        );
    }

    return (
        <>
            <Paper sx={{ margin: "auto", marginTop: 4 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 2 }}>
                    <Typography variant="h6">Modulübersicht</Typography>
                    <Button variant="contained" onClick={handleOpenDialog}>
                        Neues Modul
                    </Button>
                </Box>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Beschreibung</TableCell>
                                <TableCell align="center">Versionen</TableCell>
                                <TableCell align="right">Aktionen</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {modules.map((module) => (
                                <TableRow key={module.id}>
                                    <TableCell>{module.name}</TableCell>
                                    <TableCell>{module.description}</TableCell>
                                    <TableCell align="center">{module.versions?.length || 0}</TableCell>
                                    <TableCell align="right">
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={() => handleEditClick(module.id)}
                                        >
                                            Bearbeiten
                                        </Button>
                                        <IconButton
                                            onClick={() => handleDeleteClick(module.id, module.name)}
                                            size="small"
                                            sx={{ ml: 1 }}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            <ModuleFormDialog open={isDialogOpen} onClose={handleCloseDialog} onSubmit={handleSubmitModule} />
        </>
    );
};

export default ModuleList;
